import React from 'react';
import classnames from 'classnames';
import styled, { css } from 'styled-components';
import Option from './Option';
const StyledOptionContainer = styled.div `
  display: flex;
  flex-direction: column;
  max-height: 20.833333333rem;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;

  ${({ isClearable }) => isClearable && css `
    margin-bottom: 0.7rem;
  `}
`;
const StyledOptionWrapper = styled.div `
  padding: 0.666666667rem 1rem;
  background-color: ${({ theme, selected }) => !selected ? theme.ThemeColors.WHITE.hex : '#ebeef5'};
  cursor: pointer;
`;
const handleOptionSelection = (event, onOptionSelect, option) => {
    // We stop the propagation of the `click` event to avoid reaching the listener attached
    // to the select container element.
    event.stopPropagation();
    onOptionSelect(option);
};
const renderOptions = (options, selectedOptions, onOptionSelect, OptionComponent = Option, optionWrapperClassName, selectedOptionClassName = '') => options.map((option) => {
    const isSelected = !!selectedOptions.find((selectedOption) => selectedOption.name === option.name);
    return (React.createElement(StyledOptionWrapper, { key: option.name, className: classnames(optionWrapperClassName, { [selectedOptionClassName]: isSelected }), onClick: (event) => handleOptionSelection(event, onOptionSelect, option), selected: isSelected },
        React.createElement(OptionComponent, { option: option, isSelected: isSelected })));
});
const OptionMenu = ({ className, optionWrapperClassName, selectedOptionClassName, options, selectedOptions, onOptionSelect, optionComponent: OptionComponent, isClearable, }) => (React.createElement(StyledOptionContainer, { className: className, isClearable: isClearable }, renderOptions(options, selectedOptions, onOptionSelect, OptionComponent, optionWrapperClassName, selectedOptionClassName)));
export default OptionMenu;
